import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=06018947&"
import script from "./myNews.vue?vue&type=script&lang=js&"
export * from "./myNews.vue?vue&type=script&lang=js&"
import style0 from "./myNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports